import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_ADMIN_BOOKING_DETAILS, GET_ADMIN_BOOKING_DETAILS_SUCCESS, GET_ADMIN_BOOKING_DETAILS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getAdminBookingDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* Query contract: { booking_id, project_code } — the source booking id shown on the ticket, not a UUID */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/booking-details`,
      method: 'GET',
      headers: { ...filteredHeaders },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_ADMIN_BOOKING_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to fetch booking details'}`);
      yield put({
        type: GET_ADMIN_BOOKING_DETAILS_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to fetch booking details');
    yield put({ type: GET_ADMIN_BOOKING_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetAdminBookingDetails() {
  yield takeEvery(GET_ADMIN_BOOKING_DETAILS, getAdminBookingDetails);
}

function* getAdminBookingDetailsSaga() {
  yield all([fork(watchGetAdminBookingDetails)]);
}

export default getAdminBookingDetailsSaga;
